import { render, staticRenderFns } from "./TypesTopics.vue?vue&type=template&id=bbeba93c&scoped=true&"
import script from "./TypesTopics.vue?vue&type=script&lang=js&"
export * from "./TypesTopics.vue?vue&type=script&lang=js&"
import style0 from "./TypesTopics.vue?vue&type=style&index=0&id=bbeba93c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbeba93c",
  null
  
)

export default component.exports